import { applyMiddleware, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import promise from 'redux-promise';
import thunk from 'redux-thunk';
import sequenceAction from 'redux-sequence-action';
import AppConfig from '../appConfig';
import allReducers from './reducers';
import persistedState from './persistedState';
import { getDashboardData } from '../actions/dashboardActions';
import { getTodayAttendanceTime } from '../actions/employeeActions';
import { getEmployeeData } from '../actions/leaveAction';
import { getUsers } from '../actions/attendanceAction';
import { getFormattedTiming } from '../common/utils';

const logger = createLogger({
    // ...options
});

const configureStore = () => {
    var applyMiddlewareObj;
    if (AppConfig.reduxLogger) {
        applyMiddlewareObj = applyMiddleware(thunk, promise, logger, sequenceAction);
    } else {
        applyMiddlewareObj = applyMiddleware(thunk, promise, sequenceAction);
    }
    const store = createStore(
        allReducers,
        persistedState,
        applyMiddlewareObj
    );
    // When not using Auth0, fetch initial data immediately (token getter not needed).
    // When using Auth0, InitDataFetcher dispatches after token getter is set.
    if (!AppConfig.auth0.useAuth0) {
        store.dispatch(getDashboardData());
        store.dispatch(getUsers());
        store.dispatch(getTodayAttendanceTime(getFormattedTiming(new Date())));
        store.dispatch(getEmployeeData());
    }
    return store;
};

export { getDashboardData, getTodayAttendanceTime, getEmployeeData, getUsers, getFormattedTiming };

export default configureStore;
